<template>
  <div id="page-selects">
    <v-dialog v-model="dialogShowImage" persistent width="230">
      <v-card>
        <v-btn color="pink" dark small absolute right fab @click.native="hideToggleLockJobNumber">
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-text>
          <v-avatar
          :tile="true"
          :size="200"
          class="grey lighten-4"
          >
            <img :src="utils.imageProfile(selectedImage)" alt="" width="300" height="300">
          </v-avatar>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-container grid-list-xl fluid class="pa-2">
      <div class="d-flex align-center justify-space-between mb-4">
        <div>
          <h2 class="section-title">
          {{$t('userMaintenance')}}
          </h2>
          <div class="text-h6 font-weight-bold"></div>
          <div class="text-caption grey--text">
          </div>
        </div>

        <div class="d-flex align-center" style="gap: 12px;">
          <v-btn color="primary" @click="openNewUser">
          <v-icon left>mdi-plus</v-icon>
          {{$t('user.buttonNewUser')}}
          </v-btn>

          <v-text-field
            v-model="vDataTable.search"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-magnify"
            placeholder="Search"
            style="width: 320px;"
          />
        </div>
      </div>
      <v-card class="table-card" outlined>
        <v-data-table
          v-model="vDataTable.selected"
          :headers="headersUser"
          :items="vDataTable.data"
          :search="vDataTable.search"
          fixed-header
          :page.sync="vDataTable.options.page"
          :itemsPerPage.sync="vDataTable.options.itemsPerPage"
          :options.sync="vDataTable.options"
          :height="$vuetify.breakpoint.height - 290"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="user_id"
          class="elevation-1">
          <template v-slot:item.actions="{ item }">
            <!-- <v-icon color="teal" small class="mr-2" @click="editItem(item)">edit</v-icon> -->
            <v-btn icon small text elevation="0" color="primary" @click="editItem(item)">
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
            <!-- <v-icon color="pink" small @click="deleteItemConfirm(item)">delete</v-icon> -->
          </template>
          <template v-slot:item.active_flag_desc="{ item }">
            <v-chip
              :color="item.active_flag === 'Y' ? 'green' : 'red'"
              dark
              small
              label
              class="font-weight-bold"
            >
              <v-icon left x-small>
                {{ item.active_flag === 'Y' ? 'mdi-check-circle' : 'mdi-minus-circle' }}
              </v-icon>
              {{ item.active_flag === 'Y' ? 'Active' : 'Inactive' }}
            </v-chip>
          </template>
          <template v-slot:item.data-table-no="{ item, index }">
            {{index + 1}}
          </template>
          <template v-slot:no-data>
            <v-alert type="info" border="bottom" colored-border elevation="2">
              {{$t('noData')}}
            </v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert type="warning" border="bottom" colored-border elevation="2">
              {{stringFormat($t('searchNotFound'),vDataTable.search)}}
            </v-alert>
          </template>
          <template v-slot:footer>
            <tr class="sticky-table-footer" style="position: absolute" >
                <td>Selected({{vDataTable.selected.length}})s</td> 
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="dialog.dialogProgress" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              <span class="font-weight-bold dark white--text">{{progressMessage}}</span>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
          <!-- </v-widget>
        </v-flex>
      </v-layout> -->
    </v-container>
    <v-dialog v-model="dialog.dialogAddEditWindow" max-width="500px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">  
                <v-text-field dense outlined hide-details v-bind:label="$t('userID')" v-model="vDataTable.editedItem.user_id"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field dense outlined hide-details label="First Name" v-model="vDataTable.editedItem.first_name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field dense outlined hide-details label="Last Name" v-model="vDataTable.editedItem.last_name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field dense outlined hide-details mask="phone" v-model="vDataTable.editedItem.phone" label="Phone"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field dense outlined hide-details v-model="vDataTable.editedItem.email" label="Email"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field dense outlined hide-details label="Password" v-model="vDataTable.editedItem.password"
                :append-icon="e3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="e3 ? 'password' : 'text'"
                @click:append="e3 = !e3"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  class="ma-0 pa-0 shrink mx-0"
                  outlined
                  hide-details
                  dense
                  clearable
                  :items="dropDownData.pc_profile_def"
                  item-value="profile_skey"
                  item-text="profile_name"
                  v-model="vDataTable.editedItem.profile_skey"
                  label="Profile"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  class="ma-0 pa-0 shrink mx-0"
                  outlined
                  hide-details
                  dense
                  clearable
                  :items="dropDownData.s_dept"
                  item-value="dept_id"
                  item-text="description"
                  v-model="vDataTable.editedItem.dept"
                  label="Department"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  class="ma-0 pa-0 shrink mx-0"
                  outlined
                  hide-details
                  dense
                  clearable
                  :items="dropDownData.facility"
                  item-value="facility_cd"
                  item-text="facility_name"
                  v-model="vDataTable.editedItem.facility_cd"
                  label="Facility"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-switch
                  v-model="vDataTable.editedItem.active_flag"
                  :label="`Status: ${vDataTable.editedItem.active_flag === 'Y' ? 'Active' : 'Inactive'}`"
                  true-value="Y"
                  false-value="N"
                  color="success"
                  inset
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click="save">{{$t('save')}}</v-btn>
            <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Base64Binary from 'base64-arraybuffer'
import VWidget from '@/components/VWidget'
// import { imageProfile } from '../utils'

export default {
  components: {
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEditWindow: false,
      },
      showMenu: false,
      x: 0,
      y: 0,
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          user_id: '',
          first_name: '',
          last_name: '',
          password: '',
          phone: '',
          email: '',
          sex: '',
          active_flag: 'Y',
        },
        defaultItem: {
          user_id: '',
          first_name: '',
          last_name: '',
          password: '',
          phone: '',
          email: '',
          sex: '',
          active_flag: 'Y',
        },
        options: {
          page: 1,
          itemsPerPage: 15,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      progressMessage: '',
      appSkey: -1,
      e3: true,
      dialogShowImage: false,
      selectedImage: null,
      dialogAddEditWindow: false,
      dialogProgress: false,
      searchUser: '',
      paginationUser: {
        sortBy: 'user_id',
        rowsPerPage: 10
      },
      selectedUser: [],
      dataUser: [],
      editedIndex: -1,
      editedItem: {
        user_id: '',
        first_name: '',
        last_name: '',
        password: '',
        phone: '',
        email: '',
        sex: '',
      },
      deletedIndex: -1,
      deletedItem: {
        user_id: '',
        first_name: '',
        last_name: '',
        password: '',
        phone: '',
        email: '',
      },
      defaultItem: {
        user_id: '',
        first_name: '',
        last_name: '',
        password: '',
        phone: '',
        email: '',
        sex: '',
      },
      lstUserProfile: [],
      dropDownData: [],
    }
  },

  computed: {
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? this.$t('newUser') : this.$t('editUser')
    },
    /* headers () {
      return [
        { text: '#', align: 'center', value: 'data-table-no' },
        { text: '', align: 'center', value: 'data-table-select' },
        { text: 'win_skey', align: 'left', value: 'win_skey' },
        { text: this.$t('actions'), value: 'actions', sortable: false },
        { text: this.$t('navWindow.windowName'), value: 'win_name', align: 'right' },
        { text: this.$t('navWindow.windowComment'), value: 'window_comment', align: 'left' },
        { text: this.$t('createUser'), value: 'create_user_id', align: 'left' },
        { text: this.$t('createDate'), value: 'create_date', align: 'left' },
        { text: this.$t('maintUser'), value: 'maint_user_id', align: 'left' },
        { text: this.$t('maintDate'), value: 'maint_date', align: 'left' },
        { text: 'File', value: 'win_dll_name', align: 'left' },
      ]
    } */
    headersUser () {
      return [
        { text: '#', align: 'center', value: 'data-table-no' },
        /* { text: '', align: 'center', value: 'data-table-select' }, */
        { text: this.$t('actions'), sortable: false, value: 'actions' },
        { text: this.$t('userID'), align: 'left', value: 'user_id' },
        /* { text: this.$t('picture'), value: 'picture_base64', align: 'left' }, */
        { text: this.$t('firstName'), value: 'first_name', align: 'left' },
        { text: this.$t('lastName'), value: 'last_name', align: 'left' },
        { text: this.$t('profileName'), value: 'profile_name', align: 'left' },
        { text: this.$t('facilityCode'), value: 'facility_cd', align: 'left' },
        { text: this.$t('status'), value: 'active_flag_desc', align: 'left' }
      ]
    }
  },

  watch: {
    'dialog.dialogAddEditWindow' (val) {
      val || this.close()
    }
  },

  created: function () {
    this.retrieveUser()
    this.retrieveUserProfile()
    this.retrieveDropDown()
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: '',
        user_id: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        password: '',
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: '',
        user_id: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        password: '',
      }
    },
    showToggleLockJobNumber (picture) {
      this.dialogShowImage = true
      this.selectedImage = picture
    },
    hideToggleLockJobNumber () {
      this.dialogShowImage = false
    },
    printReportUserInfo (item) {
      this.dialog.dialogProgress = true
      this.progressMessage = 'กรุณารอสักครู่'
      var dataJSON = []
      var data = []
      data.push({ 'user_id': item.user_id, 'first_name': item.first_name, 'last_name': item.last_name, 'employee_no': item.employee_no == null ? '' : item.employee_no, 'facility_cd': item.facility_cd == null ? '' : item.facility_cd, 'picture_base64': item.picture_base64 == null ? 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=' : item.picture_base64 })
      dataJSON.push({'data': data})
      this.axios.post(process.env.VUE_APP_API + '/getReportByJSONBase64', {
        report_name: 'user_info',
        data_json: dataJSON}, {})
        .then(response => {
          if (response.data.isSuccess) {
            const blob = new Blob([Base64Binary.decode(response.data.pdf_base64)], {type: 'application/pdf; charset=utf-8'})
            const url = window.URL.createObjectURL(blob)
            window.open(url)
            this.dialog.dialogProgress = false
          } else {
            this.dialog.dialogProgress = false
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.dialog.dialogProgress = false
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveUser () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      try {
        const response = await this.axios.post(process.env.VUE_APP_API + '/user/retrieveUser' + process.env.VUE_APP_DATABASE_TYPE)
        if (response.data.isSuccess) {
          this.vDataTable.data = response.data.data
          // ใช้ nextTick เพื่อรอให้ Vue วาด Table เสร็จก่อนค่อยปิด Loading
          this.$nextTick(() => {
            this.dialog.dialogProgress = false
          })
        } else {
          this.dialog.dialogProgress = false
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      } catch (e) {
        this.dialog.dialogProgress = false
        this.$swal({type: 'error', title: e.message})
      }
    },
    async addUser (userID, password, firstName, lastName, phone, email, profileSkey, dept, facilityCd, activeFlag) {
      await this.axios.post(process.env.VUE_APP_API + '/user/addUser' + process.env.VUE_APP_DATABASE_TYPE, {
        user_id: userID,
        password: password,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        email: email,
        profile_skey: profileSkey,
        dept: dept,
        facility_cd: facilityCd,
        active_flag: activeFlag
      })
        .then(response => {
          if (response.data.isSuccess) {
            /* console.log(response.data, 'response.data')
            this.vDataTable.editedItem.user_skey = response.data.data.user_skey */
            this.vDataTable.data.push(this.vDataTable.editedItem)
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async updateUser (userID, password, firstName, lastName, phone, email, profileSkey, dept, facilityCd, activeFlag) {
      await this.axios.post(process.env.VUE_APP_API + '/user/updateUser' + process.env.VUE_APP_DATABASE_TYPE, {
        user_id: userID,
        password: password,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        email: email,
        profile_skey: profileSkey,
        dept: dept,
        facility_cd: facilityCd,
        active_flag: activeFlag
      })
        .then(response => {
          if (response.data.isSuccess) {
            const targetItem = this.vDataTable.data[this.vDataTable.editedIndex]
            Object.assign(targetItem, this.vDataTable.editedItem)
            targetItem.active_flag_desc = activeFlag === 'Y' ? 'Active' : 'Inactive'
            const profile = this.dropDownData.pc_profile_def.find(p => p.profile_skey === profileSkey)
            if (profile) targetItem.profile_name = profile.profile_name
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    deleteUser () {
      var userID = this.deletedItem.user_id
      this.dataUser.splice(this.deletedIndex, 1)
      this.axios.post(process.env.VUE_APP_API + '/user/deleteUser' + process.env.VUE_APP_DATABASE_TYPE, {
        user_id: userID
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    toggleAll () {
      if (this.selectedUser.length) this.selectedUser = []
      else this.selectedUser = this.dataUser.slice()
    },
    changeSort (column) {
      if (this.paginationUser.sortBy === column) {
        this.paginationUser.descending = !this.paginationUser.descending
      } else {
        this.paginationUser.sortBy = column
        this.paginationUser.descending = false
      }
    },
    /* editItem (item) {
      this.editedIndex = this.dataUser.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogAddEditWindow = true
    }, */
    openNewUser () {
      this.editedIndex = -1
      // คัดลอกค่าจาก defaultItem (ที่มี active_flag = 'Y') มาใส่ใน editedItem
      this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
      this.dialog.dialogAddEditWindow = true
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEditWindow = true
    },
    async deleteItemConfirm (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: 'คุณต้องการที่จะลบข้อมูล User?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteUser(this.vDataTable.editedItem)
          if (val !== undefined) {
            this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
          }
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEditWindow = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedIndex > -1) {
        await this.updateUser(this.vDataTable.editedItem.user_id,
          this.vDataTable.editedItem.password,
          this.vDataTable.editedItem.first_name,
          this.vDataTable.editedItem.last_name,
          this.vDataTable.editedItem.phone,
          this.vDataTable.editedItem.email,
          this.vDataTable.editedItem.profile_skey,
          this.vDataTable.editedItem.dept,
          this.vDataTable.editedItem.facility_cd,
          this.vDataTable.editedItem.active_flag)
      } else {
        await this.addUser(this.vDataTable.editedItem.user_id,
        this.vDataTable.editedItem.password,
        this.vDataTable.editedItem.first_name,
        this.vDataTable.editedItem.last_name,
        this.vDataTable.editedItem.phone,
        this.vDataTable.editedItem.email,
        this.vDataTable.editedItem.profile_skey,
        this.vDataTable.editedItem.dept,
        this.vDataTable.editedItem.facility_cd,
        this.vDataTable.editedItem.active_flag)
      }
      this.close()
    },
    resetPassword () {
      this.$swal({
        text: 'Reset Password',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then((result) => {
        if (result) {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          this.axios.post(process.env.VUE_APP_API + '/user/resetPassword' + process.env.VUE_APP_DATABASE_TYPE)
            .then(response => {
              if (response.data.isSuccess) {
                this.dialog.dialogProgress = false
                this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              } else {
                this.dialog.dialogProgress = false
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(e => {
              this.dialog.dialogProgress = false
              this.$swal({type: 'error', title: e.message})
            })
          /* await this.axios.post(process.env.VUE_APP_API + '/user/resetPassword' + process.env.VUE_APP_DATABASE_TYPE, {
            user_id: 'userID'
          })
            .then(response => {
              if (response.data.isSuccess) {
                this.dialog.dialogProgress = false
                this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              } else {
                this.dialog.dialogProgress = false
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(e => {
              this.dialog.dialogProgress = false
              this.$swal({type: 'error', title: e.message})
            }) */
        }
      })
    },
    retrieveDropDown () {
      this.axios.post(process.env.VUE_APP_API + '/user/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
      })
      .then(response => {
        if (response.data.isSuccess) {
          this.dropDownData = response.data.data[0]
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
    },
    async retrieveUserProfile () {
      /* this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting') */
      await this.axios.post(process.env.VUE_APP_API + '/user/retrieveUserProfile' + process.env.VUE_APP_DATABASE_TYPE)
        .then(response => {
          if (response.data.isSuccess) {
            /* this.dialog.dialogProgress = false */
            this.lstUserProfile = response.data.data
          } else {
            /* this.dialog.dialogProgress = false */
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          /* this.dialog.dialogProgress = false */
          this.$swal({type: 'error', title: e.message})
        })
    },
  }
}
</script>

<style lang="css" scoped>
.dialog.centered-dialog,
.v-dialog.centered-dialog
{
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: whitesmoke;
}
.DataTable
{
    display: none;
    border: none;
}
.rounded-card
{
  display: none;
  border: none;
}
</style>